export default {
  'SET_CREDENTIALS'(state, data) {
    state.credentials = data;
  },
  'SET_LOADING'(state, val) {
    state.loading = val;
  }
};
